import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import TextInfo from '@bit/gerenciatd.unifiedcomponents.text-info';
import ProductItem from '@bit/gerenciatd.unifiedcomponents.product-item';
import Select, { SELECT_SEGMENT } from '@bit/gerenciatd.formskeleton.select';
import { getDeviceKindDependsOnViewPort } from '@bit/gerenciatd.utils.common';
// import Button from '@bit/gerenciatd.unifiedcomponents.button';
import ProductList from '@bit/gerenciatd.unifiedcomponents.product-list';
import './Recommendations.scss';
import { generateBgRecommendations } from './recommendationsUtils';

// const COMPONENT_NAME = 'recommendations';

export const BG_COLOR = {
  GREY_1: 'grey1',
  GREY_8: 'grey8',
  GREY_7: 'grey7',
}

// indica cuántas ofertas se muestran en pantalla según el dispositivo.
const MAX_OFFERS_SCREEN = {
  pc: 4,
  tablet: 4,
  mobile: 1,
}


const Recommendations = (props) => {
  const {
    components, bgColor,
  } = props;
  let { bgImage } = props;
  const [recomSelect, setRecomSelect] = useState(0);
  const width = window.innerWidth;

  const { recom } = components;

  const selectList = [];
  if (recom.length) {
    recom.map((item) => {
      selectList.push({
        label: item.question,
        value: item.position,
      });
    });
  }

  const items = recom[recomSelect].ProductList;
  const device = getDeviceKindDependsOnViewPort();

  let order = recom[recomSelect].position;
  const offersNumber = Object.keys(items.components).length;
  const isCaroussel = (offersNumber > MAX_OFFERS_SCREEN[device]);
  const productListItems = [];
  if (!isCaroussel) {
    const itemKeyList = items.components ? Object.keys(items.components) : [];

    itemKeyList.forEach((key) => {
      if (key.indexOf('ProductItemCard') > -1) {
        const currentProductItemData = items.components[key];
        currentProductItemData.name = `${key}`;
        productListItems.push(currentProductItemData);
      }
    })
  }

  const selectOrder = (item) => {
    setRecomSelect(item);
    order = item.question;
  }

  if (!props) {
    return null;
  }

  useEffect(() => {
    if (bgImage) {
      bgImage = generateBgRecommendations('idRecommendations', bgImage);
    }
  }, []);

  if (components) {
    return (
      <div id="idRecommendations" className={`recommendations ${bgImage ? '' : `recommendations_bgColor--${bgColor}`}`}>
        <div className="placer container">
          {components && components.titulo && (
          <TextInfo {...components.titulo} className="mainTitle" />
          )}
          {components && components.subtitulo && (
          <TextInfo {...components.subtitulo} className="subTitle" />
          )}
          <div className="SelectorQuestion__filter-wrapper">
            <div className="SelectorQuestion__filter-list">
              <Select
                segment={SELECT_SEGMENT.EMP}
                hideTitle="true"
                title=""
                name="Recommendations"
                options={selectList}
                defaultValue={order}
                onChange={selectOrder}
                width="full"
              />
            </div>
          </div>
          { width >= 767 && (
          <div className="wrapper__number-solutions">
            <TextInfo
              text={`${offersNumber} soluciones recomendadas`}
              fontType="font-light"
              color="white"
              kind="span"
              size="title045"
              segment="emp"
              align="left"
              display="block"
            />
          </div>
          )}
          <ProductList {...items} key={recom[recomSelect].position} ItemComponent={ProductItem} isSlider />
          {/* { isCaroussel && (
            <ProductList {...items} key={offersNumber} segment="emp" />
          ) */}
          {/* {!isCaroussel && (
          <div className="recommendations__wrapper__noList">
            {productListItems && productListItems.map((item) => {
              return (
                <ProductItem
                  key={item.name}
                  bgColor={item.itemBgColor}
                  features={item.features}
                  featureStyles={item.featureStyles}
                  img={item.img}
                  brandImg={item.brandImg}
                  components={item.components}
                  border={item.border}
                  boxShadow={item.boxShadow}
                  onMouseEnter={item.onMouseEnter}
                  segment={item.segment}
                  productInfoHeight={item.productInfoHeight}
                  taggingInfo={items.taggingInfo}
                  className="recommendations__product-item__noList"
                />
              )
            })}
          </div>
          )} */}
          {/* Comentado por si es necesarrio a futuro */}
          {/* { width >= 767 && (
          <div className="wrapper__button">
            <Button
              border="no-border-radius"
              className="comunication-buton"
              color="white_blue"
              font="regular"
              label="Ir al recomendador"
              labelSize="medium"
              link="https://www.movistar.es/empresas/fusion/recomendador/"
              segment="emp"
              size={{ h: 'large', w: 'liquid' }}
              taggingInfo={{
                componentContent: 'ir-al-recomendador',
                componentName: COMPONENT_NAME,
                componentProduct: '',
                componentVariation: 'all',
              }}
            />
          </div>
          )} */}
        </div>
      </div>
    )
  }
  return null;
}

Recommendations.propTypes = {
  bgColor: PropTypes.oneOf([
    BG_COLOR.GREY_1,
    BG_COLOR.GREY_8,
    BG_COLOR.GREY_7,
  ]),
  bgImage: PropTypes.string.isRequired,
}

Recommendations.defaultProps = {
  bgColor: BG_COLOR.GREY_1,
}

export default Recommendations;
